/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Confirm_Delete_File_TitleInputs */



/**
* | output |
* | --- |
* | "Delete File" |
*
* @param {Spaces_Confirm_Delete_File_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_confirm_delete_file_title = /** @type {((inputs?: Spaces_Confirm_Delete_File_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Confirm_Delete_File_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei löschen")
	return /** @type {LocalizedString} */ ("Delete File")
});